__turbopack_context__.v({
  "actions": "GalleryModal-module-scss-module__jGINbq__actions",
  "body": "GalleryModal-module-scss-module__jGINbq__body",
  "caption": "GalleryModal-module-scss-module__jGINbq__caption",
  "closeButton": "GalleryModal-module-scss-module__jGINbq__closeButton",
  "dialog": "GalleryModal-module-scss-module__jGINbq__dialog",
  "dialogAppear": "GalleryModal-module-scss-module__jGINbq__dialogAppear",
  "dialogAppearActive": "GalleryModal-module-scss-module__jGINbq__dialogAppearActive",
  "dialogEnter": "GalleryModal-module-scss-module__jGINbq__dialogEnter",
  "dialogEnterActive": "GalleryModal-module-scss-module__jGINbq__dialogEnterActive",
  "dialogExit": "GalleryModal-module-scss-module__jGINbq__dialogExit",
  "dialogExitActive": "GalleryModal-module-scss-module__jGINbq__dialogExitActive",
  "fade-in": "GalleryModal-module-scss-module__jGINbq__fade-in",
  "figure": "GalleryModal-module-scss-module__jGINbq__figure",
  "header": "GalleryModal-module-scss-module__jGINbq__header",
  "image": "GalleryModal-module-scss-module__jGINbq__image",
  "list": "GalleryModal-module-scss-module__jGINbq__list",
  "nav": "GalleryModal-module-scss-module__jGINbq__nav",
  "no-transform": "GalleryModal-module-scss-module__jGINbq__no-transform",
  "rotate": "GalleryModal-module-scss-module__jGINbq__rotate",
  "skipLink": "GalleryModal-module-scss-module__jGINbq__skipLink",
  "skipLinkLong": "GalleryModal-module-scss-module__jGINbq__skipLinkLong",
  "skipLinkShort": "GalleryModal-module-scss-module__jGINbq__skipLinkShort",
  "video": "GalleryModal-module-scss-module__jGINbq__video",
});
